import React from 'react'
import clsx from 'clsx'
import OpalCard from '../../../../opal/OpalCard'
import { sharedPropTypes } from '../propTypes'
import RSSFeedItemFooter from '../components/RSSFeedItemFooter'
import RSSFeedItemCollapsibleBody from '../components/RSSFeedItemCollapsibleBody'
import useNormalizedConfig from '../../hooks/useNormalizedValues'

function CardVariant ({
  item,
  title: _title,
  summary: _summary,
  body,
  image: _image,
  contentType,
  footer,
  className = 'relative',
  style
}) {
  const title = useNormalizedConfig(item, _title)
  const summary = useNormalizedConfig(item, _summary)
  const image = useNormalizedConfig(item, _image)

  return (
    <OpalCard
      className={clsx('flex flex-col h-full', className)}
      style={style}
    >
      {image?.value && (
        <img
          src={image?.value}
          alt={title?.value ?? ''}
          className={clsx('w-full object-cover', image.className)}
          style={{
            borderRadius: 'var(--border-radius-md) var(--border-radius-md) 0 0',
            borderBottom: '1px solid var(--color-neutral-200)',
            maxHeight: '15em',
            objectPosition: 'top center',
            ...image.style
          }}
        />
      )}
      <div className='flex flex-col gap-2 p-4 flex-1 relative'>
        {title.value && (
          <h3 className={clsx('font-size-md font-weight-600 m-0', title.className)} style={title.style}>
            {title.value}
          </h3>
        )}
        {summary.value && (
          <p className={clsx('font-size-sm text-secondary m-0', summary.className)} style={summary.style}>
            {summary.value}
          </p>
        )}
        <RSSFeedItemCollapsibleBody
          item={item}
          body={body}
          contentType={contentType}
        />
        <RSSFeedItemFooter item={item} config={footer} />
      </div>
    </OpalCard>
  )
}

CardVariant.propTypes = {
  ...sharedPropTypes
}

export default CardVariant
